
<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/" i18n>Home</a></li>
                <li i18n>Book Details</li>
                <li></li>
            </ul>
            <h2 i18n>Book Details</h2>
        </div>
    </div>
</div>
<div
    class="instructor-details-area pt-100 pb-70"
    [class.dark-instructor-details-area]="themeService.isDark()"
>
    <div class="container">
        <div class="instructor-details-desc">
            <div class="row">
                <div class="col-lg-4 col-md-4">
                    <div class="instructor-details-sidebar">
                        <img [src]="imageURL + book?.image" alt="image" style="max-height:35em">
                    </div>
                </div>
                <div class="col-lg-8 col-md-8">
                    <div class="instructor-details">
                        <h3>{{book?.title}}</h3> 
                        <!-- <span class="sub-title"><strong i18n>Book Category </strong>: {{book?.related_category.category_name}}</span> -->
                        <div class="instructor-details-info">
                            <div class="row">
                                <div class="col-lg-6 col-md-12">
                                    <ul>
                                        <li>
                                            <i class='bx bxs-group'></i>
                                            <span i18n>Authors</span>
                                            <a>{{book?.authors}}</a>
                                        </li>
                                        <li>
                                            <i class='bx bx-group'></i>
                                            <span i18n>Editors</span>
                                            <a>{{book?.editors}}</a>
                                        </li>
                                        <li>
                                            <i class='bx bx-group'></i>
                                            <span i18n>Translator</span>
                                            <a>{{book?.translator}}</a>
                                        </li>
                                        <li>
                                            <i class='bx bxs-graduation'></i>
                                            <span i18n>Edition</span>
                                            {{book?.edition}}
                                        </li>
                                        <li>
                                            <i class='bx bxs-graduation'></i>
                                            <span i18n>Volume</span>
                                            {{book?.volume}}
                                        </li>
                                        
                                    </ul>
                                </div>
                                <div class="col-lg-6 col-md-12">
                                    <ul>
                                        <li>
                                            <i class='bx bxs-graduation'></i>
                                            <span i18n>TERAJ</span>
                                            {{book?.teraj}}
                                        </li>
                                        <li>
                                            <i class='bx bxs-graduation'></i>
                                            <span i18n>NUMBER OF PAGE</span>
                                            {{book?.number_of_page}}
                                        </li>
                                        <li>
                                            <i class='bx bxs-graduation'></i>
                                            <span i18n>BOOK CATEGORY</span>
                                            {{book?.related_category.category_name}}
                                        </li>
                                        <li *ngIf="book?.book">
                                            <a [href]="imageURL+ book?.book" target="_blank">
                                                <i class='bx bx-download bx-tada bx-rotate-180' style='color:#151e3f; padding: 5%; font-size:xx-large' ></i>
                                            </a>
                                        </li>
                                        
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>